export enum ExtOrdersActionTypes {
  API_RESPONSE_SUCCESS = '@@extOrders/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@extOrders/API_RESPONSE_ERROR',

  LIST_EXTORDERS = '@@extOrders/LIST_EXTORDERS',
  LIST_ENTERPRISEEXTORDERS = '@@extOrders/LIST_ENTERPRISEEXTORDERS',

  RESET = '@@extOrders/RESET',
}